<template>
  <div class="wlx-stu-basic-wrapper">
    <el-select v-model="siteId_" clearable placeholder="请选择站点" @change="siteChange">
      <el-option v-for="item in SiteList" :key="item.Id" :label="item.SiteTitle" :value="item.Id"></el-option>
    </el-select>
    <el-table :data="attestationList" style="width: 100%">
      <el-table-column label="选中" width="136">
        <template slot-scope="scope">
          <el-radio v-model="attestationId" :label="scope.row.Id">
            <i></i>
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column label="标题" prop="Title"></el-table-column>
      <el-table-column label="站点" prop="SiteName"></el-table-column>
      <el-table-column label="开始时间" prop="PulishTime"></el-table-column>
      <el-table-column label="结束时间" prop="EndTime"></el-table-column>
      <el-table-column label="内容" prop="ContentText"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="submit(scope.row.Id)">报名</el-button>
          <el-button type="success" size="mini" @click="seeInfo(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="u-page-con">
      <el-pagination
        @size-change="dilhandleSizeChange"
        @current-change="dilhandleCurrentChange"
        :current-page="dilpageIndex"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="dilpageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="diltotalCount"
      ></el-pagination>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { MU_UPATE_AUTH } from "store/index";
export default {
  data() {
    return {
      tabName: "first",
      attestationList: [],
      dilpageIndex: 1,
      dilpageSize: 10,
      diltotalCount: 0,
      SiteList: [],
      siteId_: "",
      attestationId: "",
      dialogVisible: false
    };
  },
  created() {
    this.getAttestationList();
    this.getSiteList();
  },
  methods: {
    getSiteList() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getSiteList", { type: 3 })
        .then(function(rst) {
          if (rst.code > 0) {
            that.SiteList = rst.SiteList;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    seeInfo() {},
    siteChange() {
      this.attestationId = "";
      this.getAttestationList();
    },
    dilhandleSizeChange(size) {
      this.dilpageSize = size;
      this.getAttestationList();
    },
    dilhandleCurrentChange(index) {
      this.dilpageIndex = index;
      this.getAttestationList();
    },
    handleClose(){

    },
    getAttestationList() {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/getAttestationList", {
          SiteId: that.siteId_,
          type: 3,
          page: that.pageIndex
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.attestationList = rst.attestationList;
            that.dilpageIndex = rst.pagination.pageIndex;
            that.dilpageSize = rst.pagination.pageSize;
            that.diltotalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    submit(Id) {
      var that = this;
      this.$http
        .post("/api/XOrg/StudentManager/addAttestationStu", {
          attestationId: Id,
          type: 3
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.dialogVisible = false;
            that.getAttestationStu();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.wlx-stu-basic-wrapper {
  .el-tabs__header {
    position: fixed;
    top: 60px;
    right: 0;
    height: 60px;
    width: calc(100% - 240px);
    z-index: 1000;
    background: #fff;
    text-align: right;
  }
  .el-tabs__item {
    width: 140px;
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .el-tabs__content {
    margin: 80px 0 0 30px;
    background: #fff;
    .el-tab-pane {
      padding: 20px;
    }
  }
}
</style>
